<template>
  <c-row>
    <loader v-show="loading" />
    <c-col col="6">
      <c-card>
        <c-card-header>
          <c-card-title>Edit Retur</c-card-title>
        </c-card-header>
        <c-card-body>
          <div class="form-group">
            <label>Kode Garansi</label>
            <span type="text" class="form-control"
              >{{ data.warranty_code }}
            </span>
          </div>
          <div class="form-group">
            <label>Nama Barang</label>
            <span type="text" class="form-control"
              >{{ data.sale_detail.item.name }}
            </span>
          </div>
          <div class="form-group">
            <label>Tanggal Retur</label>
            <span type="text" class="form-control"
              >{{ data.return_date | dateFormat }}
            </span>
          </div>
          <div class="form-group">
            <label>Alasan Retur</label>
            <span type="text" class="form-control">
              [{{ data.type.label }}] {{ data.return_reason }}
            </span>
          </div>
        </c-card-body>
        <c-card-footer>
          <button class="btn btn-warning mr-2" @click="doBack">
            <i class="cil-arrow-circle-left"></i> Batal
          </button>
          <button class="btn btn-success mr-2" @click="doneRepair">
            <i class="cil-check"></i> Diperbaiki
          </button>
          <button class="btn btn-primary" @click="sendToVendor">
            <i class="cil-truck"></i> Kembali Ke Vendor
          </button>
        </c-card-footer>
      </c-card>
    </c-col>
  </c-row>
</template>
<script>
import { showErrorMessage } from '../../lib/helpers';
import { HTTPAUTH } from '../../lib/httplib';
export default {
  data () {
    return {
      data: {}
    }
  },
  created () {
    const query = this.$route.query;
    if (query && query.id) {
      HTTPAUTH.get(`/api/v1/return/items/${query.id}`).then(res => {
        this.data = res.data.data
      })
    }
  },
  methods: {
    doBack () {
      this.$router.push({ path: '/return/info-sales' })
    },
    doneRepair () {
      if (!confirm('Apakah berhasil diperbaiki?')) {
        return;
      }
      HTTPAUTH.put(`/api/v1/return/repaired/${this.data.id}`).then(() => {
        this.$toasted.success('Berhasil diperbaiki').goAway();
      }).catch((eres) => {
        showErrorMessage(eres)
      })
    },
    sendToVendor () {
      if (!confirm('Barang akan dikembalikan ke Vendor')) {
        return;
      }
      HTTPAUTH.put(`/api/v1/return/send-to-vendor/${this.data.id}`).then(() => {
        this.$toasted.success('Dikembalikan ke vendor').goAway();
      }).catch((eres) => {
        showErrorMessage(eres)
      })
    }
  }
}
</script>